<template>
  <div>
    <a-form-model layout="horizontal" :model="form" :colon="false" :rules="formRule" ref="applicantForm" :label-col="{ span: 3 }" >
        <a-form-model-item label="投保人（企业名称）" prop="phName" :wrapper-col="{ lg: 6, sm: 8 }">
            <a-input v-model="form.phName" :disabled="disabledAll"></a-input>
        </a-form-model-item>
        <a-form-model-item label="证件号码" prop="phIdType" :wrapper-col="{ lg: 8, sm: 12 }">
            <a-row :gutter="10">
                <a-col :span="9">
                    <a-select v-model="form.phIdType" allow-clear :disabled="disabledAll">
                        <a-select-option v-for="item in cradTypeCode" :key="item.code" :value="item.code">{{item.name}}</a-select-option>
                    </a-select>
                </a-col>
                <a-col :span="15">
                    <a-input v-model="form.phIdNumber" :disabled="disabledAll"></a-input>
                </a-col>
            </a-row>
        </a-form-model-item>
        <a-form-model-item label="地址信息" prop="phAddress" :wrapper-col="{ lg: 10, sm: 16 }">
            <a-row :gutter="10">
                <a-col :span="7">
                    <a-select v-model="form.phAddress[0]" allow-clear show-search :filter-option="filterReferCode" @change="citySelectChange" :disabled="disabledAll">
                        <a-select-option v-for="item in cityCode" :key="item.value" :value="`${item.value}`">{{item.name}}</a-select-option>
                    </a-select>
                </a-col>
                <a-col :span="7">
                    <a-select v-model="form.phAddress[1]" allow-clear show-search :filter-option="filterReferCode" @change="distCodeChange" :disabled="disabledAll">
                        <a-select-option v-for="item in distCode" :key="item.value" :value="`${item.value}`">{{item.name}}</a-select-option>
                    </a-select>
                </a-col>
                <a-col :span="10">
                    <a-input v-model="phAddressCN[2]" :disabled="disabledAll"></a-input>
                </a-col>
            </a-row>
        </a-form-model-item>
        <a-form-model-item label="联系人" prop="contactsName" :wrapper-col="{ lg: 6, sm: 8 }">
            <a-input v-model="form.contactsName" :disabled="disabledAll"></a-input>
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="contactsPhone" :wrapper-col="{ lg: 6, sm: 8 }">
            <a-input v-model="form.contactsPhone" :disabled="disabledAll"></a-input>
        </a-form-model-item>
        <a-form-model-item label="电子邮箱" prop="contactsEmail" :wrapper-col="{ lg: 6, sm: 8 }">
            <a-input v-model="form.contactsEmail" :disabled="disabledAll"></a-input>
        </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
export default {
    props: {
        formData: {
            required: true,
            type: Object
        },
        disabledAll: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            form: {
                phName: '',
                contactsName: '',
                phIdType: '',
                phAddress: [],
                contactsPhone: '',
                contactsEmail: ''
            },
            phAddressCN: [], // 地址选择的name及详细地址
            formRule: {
                phName: [
                    { required: true, message: "投保人名称不能为空！"}
                ],
                phIdType: [
                    { required: true, validator: this.phIdTypeValid }
                ],
                phAddress: [
                    { required: true, validator: this.phAddressValid }
                ],
                contactsName: [
                    { required: true, message: "联系人姓名不能为空！"}
                ],
                contactsPhone: [
                    { required: true, message: "请输入联系人手机号码"},
                    { pattern: this.$regTest.checkPhone, message: '联系人电话不正确', trigger: 'blur' }
                ],
                contactsEmail: [
                    { required: true, message: "请输入联系人邮箱"},
                    { pattern: this.$regTest.checkEmail, message: '联系人邮箱不正确', trigger: 'blur' }
                ]
            },
            cradTypeCode: [
                {code: '01', name: '组织机构代码证'},
                {code: '02', name: '营业执照'},
                {code: '03', name: '税务登记证'},
                {code: '04', name: '统一社会信用代码'},
                {code: '99', name: '其他'}
            ],
            cityCode: window.addressOptions,
            distCode: []
        }
    },
    watch: {
        formData: {
            deep: true,
            handler: function(val) {
                if (val) {
                    console.log('done')
                    let { phAddress } = val
                    if(phAddress) {
                        phAddress = phAddress.split(',')
                        this.phAddressCN = phAddress[0].split('-')
                        phAddress = phAddress[1].split('-')
                        this.getDistCode(phAddress[0])
                    }
                    this.form = {
                        ...val,
                        phAddress: phAddress || []
                    }
                }
            }
        }
    },
    methods: {
        // 证件号码校验规则
        phIdTypeValid(rule, value, callback) {
            const { phIdType, phIdNumber } = this.form
            if (!phIdType ) {
                return callback(new Error('证件号类型不能为空'))
            }
            if (!phIdNumber ) {
                return callback(new Error('证件号码不能为空'))
            }
            callback()
        },
        // 地址校验规则
        phAddressValid(rule, value, callback) {
            // const { phAddress } = this.form
            if (!this.phAddressCN || !this.phAddressCN.length) {
                return callback(new Error('地址信息不能为空'))
            }
            const isEmptyItem = this.phAddressCN.some(item => {
                return !item
            })
            if (this.phAddressCN.length < 3 || isEmptyItem ) {
                return callback(new Error('地址信息请填写完整'))
            }
            callback()
        },
        // 向父组件提交数据
        submitHandler() {
            return new Promise((resolve, reject) => {
                this.$refs.applicantForm.validate(valid => {
                    if (!valid){
                        reject(new Error())
                        return false;
                    }
                    // 地址需要转换成name-name-detail,code-code格式
                    let { phAddress, phName, phIdType, phIdNumber, contactsName, contactsPhone, contactsEmail } = this.form
                    if (phAddress && phAddress.length) {
                        phAddress = this.phAddressCN.join('-') + ',' + phAddress.join('-')
                    } else {
                        phAddress = undefined
                    }
                    const data = {
                        phName, phIdType, phIdNumber, contactsName, contactsPhone, contactsEmail,
                        phAddress: phAddress
                    }
                    resolve(data)
                    this.$emit('collectData', data)
                })
            })
        },
        // 选择或清空省信息 重置市字段内容和码表
        citySelectChange(val) {
            this.form.phAddress[1] = undefined
            if (! val) {
                this.distCode = []
                this.phAddressCN[0] = undefined
                this.phAddressCN[1] = undefined
                return false;
            }
            this.phAddressCN[0] = this.getDistCode(val)
        },
        getDistCode(val) {
            val = val * 1 // 转成number类型
            for(let i = 0; i < this.cityCode.length; i ++) {
                if (this.cityCode[i].value == val) {
                    this.distCode = this.cityCode[i].children
                    return this.cityCode[i].name
                }
            }
        },
        // 选择或清空省信息 重置市字段内容和码表
        distCodeChange(val){
            if(! val) {
                this.phAddressCN[1] = undefined
                return false
            }
            for(let i = 0; i < this.distCode.length; i ++) {
                if (this.distCode[i].value == val) {
                    this.phAddressCN[1] = this.distCode[i].name
                    return true
                }
            }
        },
        filterReferCode(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        }
    }
}
</script>

<style>

</style>